import { render, staticRenderFns } from "./TagBadge.vue?vue&type=template&id=140c7864&"
import script from "./TagBadge.vue?vue&type=script&lang=js&"
export * from "./TagBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports